module.exports = __webpack_public_path__ + "static/Thermal-2de7f70ad899c1aea96fa0aa082c7ae8.png";